import React, {useState} from 'react'
import { motion } from 'framer-motion';
import './header.css'
import NavDropDown from './nav-drop-down';
import { productArray, resourcesArray, customerArray, enterpriseArray } from './nav-data';
const buttonVariant = {
    hover: {
        opacity: '70%',
        scale: [1, 1.1, 1, 1.1, 1],
        transition: {
            delay: .2,
            duration: .3
        }
    }
}
export default function Header() {
    const [isOpen, setIsOpen] = useState(false)
    const openSidebar = () => {
        const sideBar = document.querySelector('.nav-items ul');
        sideBar.classList.toggle('on')
        setIsOpen(prev => !prev)
    }
    return (
        <div className='header'>
            <nav>
                <div className="nav-brand">
                    <h3>
                        Mayheaven
                    </h3>
                </div>
                <div className="nav-items">
                    <div className="overlay"></div>
                    <ul>
                        <li>
                            <p className="product-drop">Product</p>
                            <NavDropDown array={productArray} />
                        </li>
                        <li>
                            <p className="resources-drop">Resources</p>
                            <NavDropDown array={resourcesArray} />
                        </li>
                        <li>
                            <p className="customer-drop">Customer</p>
                            <NavDropDown array={customerArray} />
                        </li>
                        <li>
                            <p className="enterprise-drop">Enterprise</p>
                            <NavDropDown array={enterpriseArray} />
                        </li>                        <li>
                            <p>Pricing</p>
                        </li>
                        <li>
                            <p>Contact</p>
                        </li>
                    </ul>
                </div>
                <div className="user">
                    <ul>
                        <p>Login</p>
                        <motion.button
                            variants={buttonVariant}
                            whileHover="hover">
                            Get Mayheaven for free
                        </motion.button>
                        {
                            isOpen
                                ? <i className='bx bx-x' onClick={openSidebar}></i>
                                : <i className='bx bx-menu' onClick={openSidebar}></i>
                        }
                    </ul>
                </div>
            </nav>
        </div>
    )
}
